<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="300px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="10px" size="small" class="content">
      <el-form-item label="" prop="">
        <el-radio v-model="checked" label="Y">带图片</el-radio>
        <el-radio v-model="checked" label="N">不带图片</el-radio>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from "moment";
import E from "wangeditor";
import axios from "@/utils/axiosInstance";
import { getToken } from "@/utils/auth";
export default {
  name: "CRUDEdit",
  components: {},
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "导出";
    },
  },
  data() {
    return {
      loadingButtom: false,
      addForm: {
      },
      rules: {},
      checked: ''
    };
  },
  mounted() {},
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$emit('export',this.checked)
    },
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-form-item {
  margin-bottom: 18px
}

</style>
